import { render, staticRenderFns } from "./indentInfo.vue?vue&type=template&id=1732220a&scoped=true&"
import script from "./indentInfo.vue?vue&type=script&lang=js&"
export * from "./indentInfo.vue?vue&type=script&lang=js&"
import style0 from "./indentInfo.vue?vue&type=style&index=0&id=1732220a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1732220a",
  null
  
)

export default component.exports